import './accordion.scss';

class Accordion {
    constructor (element) {
        this.$accordion = element;
        this.$accordionHeaders = this.$accordion.querySelectorAll('[data-accordion="header"]');
        this.$accordionItems = this.$accordion.querySelectorAll('[data-accordion="item"]');
        this.$accordionContents = this.$accordion.querySelectorAll('[data-accordion="content"]');
        this.$accordionType = this.$accordion.getAttribute('data-accordion-type');
    }

    initialize () {
        if (!this.$accordion) return;
        this.setupAria();
        this.setEvents();
        this.setInitialOpenAccordion();
    }

    setupAria () {
        // Ensure consistent ARIA defaults
        this.$accordionHeaders.forEach(($h, idx) => {
            if (!$h.hasAttribute('aria-expanded')) $h.setAttribute('aria-expanded', 'false');
            const content = this.$accordionContents[idx] || this.$accordion.querySelector(`#${$h.getAttribute('aria-controls')}`);
            if (content && !content.hasAttribute('aria-hidden')) content.setAttribute('aria-hidden', 'true');
        });
    }

    setEvents () {
        const focusableHeaders = Array.from(this.$accordionHeaders);
        focusableHeaders.forEach(($header, index) => {
            $header.addEventListener('click', () => this.toggleByHeader($header));

            // Keyboard navigation between headers
            $header.addEventListener('keydown', (ev) => {
                const { key } = ev;
                if (key === 'ArrowDown' || key === 'ArrowUp' || key === 'Home' || key === 'End') {
                    ev.preventDefault();
                    let nextIndex = index;
                    if (key === 'ArrowDown') nextIndex = (index + 1) % focusableHeaders.length;
                    if (key === 'ArrowUp') nextIndex = (index - 1 + focusableHeaders.length) % focusableHeaders.length;
                    if (key === 'Home') nextIndex = 0;
                    if (key === 'End') nextIndex = focusableHeaders.length - 1;
                    focusableHeaders[nextIndex].focus();
                }
            });
        });
    }

    toggleByHeader ($header) {
        const $item = $header.closest('[data-accordion="item"]');
        const panelId = $header.getAttribute('aria-controls');
        const $panel = panelId ? this.$accordion.querySelector(`#${panelId}`) : $item?.querySelector('[data-accordion="content"]');
        if (!$panel) return;

        const isOpen = $header.getAttribute('aria-expanded') === 'true';

        if (isOpen) {
            this.closeItem($item, $header, $panel);
        } else {
            if (this.$accordionType === 'automatic') {
                // close others
                this.$accordionItems.forEach((it) => {
                    if (it !== $item) {
                        const h = it.querySelector('[data-accordion="header"]');
                        const p = it.querySelector('[data-accordion="content"]');
                        if (h && p) this.closeItem(it, h, p);
                    }
                });
            }
            this.openItem($item, $header, $panel);
        }
    }

    openItem ($item, $header, $panel) {
        $header.setAttribute('aria-expanded', 'true');
        $panel.setAttribute('aria-hidden', 'false');
        $item.classList.add('is--active');
    }

    closeItem ($item, $header, $panel) {
        $header.setAttribute('aria-expanded', 'false');
        $panel.setAttribute('aria-hidden', 'true');
        $item.classList.remove('is--active');
    }

    setInitialOpenAccordion () {
        this.$accordionItems.forEach(($item) => {
            if ($item.getAttribute('data-accordion-initial') !== null) {
                const $header = $item.querySelector('[data-accordion="header"]');
                if ($header) this.openItem($item, $header, $item.querySelector('[data-accordion="content"]'));
            }
        });
    }
}

export { Accordion };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $accordions = $context.querySelectorAll('[data-accordion="root"]');
        if ($accordions.length > 0) {
            for (let i = 0; i < $accordions.length; i++) {
                const accordionAPI = new Accordion($accordions[i]);
                accordionAPI.initialize();
            }
        }
    }
});
